export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "Schnell",
  text1: "Willkommen!",
  text2: "Check-in-Liste: Verwalten Sie die Registrierung Ihrer Gäste oder senden Sie ihnen einen Link.",
  text3: "Check-in-Liste",
  text4: "Exportieren",
  text5: "Neuer Check-in",
  text6: "Alle",
  text7: "Ausstehend",
  text8: "Abgeschlossen",
  text9: "Heute",
  text10: "Telefon",
  text11: "Name",
  text12: "Ausweisnummer",
  text13: "Land",
  text14: "Check-in",
  text15: "Schlüssel",
  text16: "Übergeben",
  text17: "Ausstehend",
  text18: "Vollständige Informationen ansehen",
  text19: "Unterzeichnetes Dokument",
  text20: "Alle",
  text21: "Bei der Bestätigung der Übergabe ist ein Fehler aufgetreten",
  text22: "Check-in-Informationen",
  text23: "Beim Check-in des Gastes erfasste Daten",
  text24: "Vorname",
  text25: "Nachname",
  text26: "Telefon",
  text27: "Aufenthaltsdatum",
  text28: "Dokumentart",
  text29: "Reisepass",
  text30: "Personalausweis",
  text31: "Dokumentnummer",
  text32: "Ablauf des Dokuments",
  text33: "Staatsangehörigkeit",
  text34: "Geburtsdatum",
  text35: "Geschlecht",
  text36: "Weiblich",
  text37: "Männlich",
  text38: "Schreiben Sie hier Ihre ...",
  text39:
    "Hallo [guest_name],\nwillkommen im HOTEL BARCELO MALAGA!\n\nVielen Dank, dass Sie bei uns übernachten. Wir weisen Sie darauf hin, dass der Check-out bis 10.00 Uhr möglich ist.\n\nAußerdem teilen wir Ihnen die Zugangsdaten zu unserem WLAN mit:\n\nNetzwerk: HOTEL-BARCELO\nPasswort: xkamakj1a0\n\n\nWir hoffen, dass Ihr Aufenthalt so angenehm wie möglich wird.\n\nAn der Rezeption stehen wir Ihnen rund um die Uhr zur Verfügung.\n\nHerzliche Grüße!",
  text40: "Der Name Ihrer Unterkunft ist erforderlich.",
  text41: "Die Richtlinien der Unterkunft sind erforderlich.",
  text42: "Es muss eine Willkommensnachricht enthalten sein.",
  text43: "Änderungen erfolgreich gespeichert",
  text44: "Fehler bei der Anfrage",
  text45: "Erfolgreich registriert.",
  text46: "😃 Hallo!! ",
  text47:
    " Sie haben die Erstellung Ihrer ersten Unterkunft erfolgreich abgeschlossen. Jetzt können Sie Ihren QR teilen, damit Ihre Gäste den ",
  text48: "Check-in",
  text49: "automatisch erledigen 👍",
  text50: "Die zuvor eingegebenen Felder können Sie über das Menü bearbeiten",
  text51: "Vorlageneinstellungen.",
  text52: "Herunterladen",
  text53: "Weiter",
  text54: "Check-in-Informationen.",
  text55: "Check-in-Daten",
  text56: "Datum der Anfrage:",
  text57: " um",
  text58: "Beim Check-in des Gastes erfasste Daten",
  text59: "Name",
  text60: "Nachname",
  text61: "Telefon",
  text62: "Aufenthaltsdatum",
  text63: "Dokumentart",
  text64: "Reisepass",
  text65: "Personalausweis",
  text66: "Dokumentnummer",
  text67: "Zusätzliche Informationen",
  text68: "Ablauf des Dokuments",
  text69: "Staatsangehörigkeit",
  text70: "Geburtsdatum",
  text71: "Geschlecht",
  text72: "Weiblich",
  text73: "Männlich",
  text74: "Schließen",
  text75: "Neuer Check-in",
  text76:
    "In den folgenden Optionen können Sie den Link senden oder einen manuellen Check-in anlegen.",
  text77: "Check-in",
  text78: "Manueller Check-in über das Verwaltungspanel.",
  text79: "Check-in senden",
  text80: "Buchungslink an einen Gast.",
  text81: "Wird geladen, bitte warten...",
  text82: "Jahre",
  text83: "Tage",

  // Modal exportar
  text84: `EXPORTIEREN`,
  text85: `Berichte in WACheckin exportieren`,
  text86: `Check-in-Bericht herunterladen`,
  text87: `Laden Sie die von Ihren Gästen durchgeführten Check-ins herunter und
    erhalten Sie einen detaillierten Bericht mit Angaben wie dem Check-in-Datum
    und weiteren Daten.`,
  text88: `Meldebericht herunterladen`,
  text89: `Falls die automatische Synchronisierung mit der Meldebehörde fehlschlägt,
    können Sie diesen Bericht herunterladen und die Daten Ihres Gastes
    manuell eingeben.`,

  text90: `Schlüssel übergeben`,
  text91: `Behörden`,
  text92: `Polizeibericht herunterladen`,
  text93: `Check-in löschen`,
  text94: `In Ihrer Unterkunft sind noch keine Gäste registriert`,
  text95: `Registrierte Gäste erscheinen hier`,
  text96: `EXPORTIEREN`,
  text97: `EXPORTIEREN`,
  text98: `EXPORTIEREN`,

  // Corrections

  p1: `Senden`,
  p2: `Check-in-Link`,
  p3: `Scannen`,
  p4: `Der Gast unterschreibt auf diesem Gerät`,
  p5: `Gescannt`,
  p6: `Manuell`,
  p7: `Manueller Operator`,
  p8: `Check-ins`,
  p9: `Nutzen Sie den manuellen Check-in, um Ihre Gäste direkt an der Rezeption zu registrieren`,
  p10: `Manueller Check-in`,
  p11: `Senden Sie Ihren Gästen den Link zum Online-Check-in per WhatsApp oder E-Mail, damit sie sich schon vor der Anreise registrieren können`,
  p12: `Online-Check-in senden`,
  p13: `Keine Angabe`,
  p14: `Check-in löschen`,
  p15: `Möchten Sie den Check-in wirklich löschen? Die gelöschten Daten können nicht wiederhergestellt werden`,
  p16: `Löschen`,
  p17: `Abbrechen`,
  p18: `Schöpfen Sie mit unseren Premium-Funktionen das volle Potenzial aus`,
  p19: `Automatischer Check-in per WhatsApp`,
  p20: `Übermittlung der Gästemeldung`,
  p21: `Identitätsprüfung`,
  p22: `Automatische Bewertung`,
  p23: `Cross-Selling`,
  p24: `Schlüsselverwaltung für Gäste`,
  p25: `Rechnungsstellung an Gäste`,
  p26: `Lassen Sie sich die Vorteile nicht entgehen!`,
  p27: `Auf Premium upgraden`,

  p28: `Position`,
  p29: `Zusätzliche Belastung`,
  p30: `Status`,
  p31: `Bezahlt`,
  p32: `Ausstehend`,
  p33: `Erstattet`,
  p34: `Belastung erstatten`,
  p35: `Erstatten`,
  p36: `Möchten Sie dem Gast die Belastung wirklich erstatten?`,
  p37: `Personalausweis`,
  p38: `Reisepass`,
  p39:`FILTER`,
  p40:`Abgeschlossene Check-ins`,
  p41:`Laufende Check-ins`,
  p42: `Sie haben keine laufenden Check-ins`,
  p43: `Check-in-Informationen`,
  p44: `Zugehörige Check-ins`,
  p45: `Keine zugehörigen Check-ins.`,
  p46: `Weitere Informationen:`,
  p47: `Check-in-Datum:`,
  p48: `Check-out-Datum:`,

  p49:`Gast`,
  p50:`Gäste`,


};
